import { Injectable } from "@nestjs/common";
import { EntityRepository, Repository } from "typeorm";
import { UnitCodes } from "../../unit-codes/unit-codes.entity";
import { Calibrations } from "../calibration.entity";
import { CalibrationIdReq } from "./calibration.req";


@Injectable()
@EntityRepository(Calibrations)
export class CalibrationRepo extends Repository<Calibrations> {

    constructor() {
        super();
    }

    async getAllCalibrations(req?: CalibrationIdReq): Promise<any> {
        const query = this.createQueryBuilder('ed')
            .select([
                'ed.calibration_id AS calibrationId',
                'ed.machine_description AS machineDescription',
                'ed.barcode_no AS barcodeNo',
                'ed.instrument AS instrument',
                'ed.instrument_make AS instrumentMake',
                'ed.model_type AS modelType',
                'ed.serial_no AS serialNo',
                'ed.calibration_range AS calibrationRange',
                'ed.calibration_due_on AS calibrationDueOn',
                'ed.plant AS plant',
                'ed.location AS location',
                'ed.calibration_frequency AS calibrationFrequency',
                'unc.unit_name AS unitName',
                'ed.is_active as isActive' ,
                'ed.version_flag as versionFlag'
            ])
            .leftJoin(
                UnitCodes, 'unc',
                'unc.unit_code_id = ed.plant'
            )
            .where('ed.calibration_id > 0'); // Add the initial WHERE clause here
    
        // Add the dynamic condition based on the `req` object
        if (req) {
            if (req.plant && req.plant > 0) {
                query.andWhere('ed.plant = :plant', { plant: req.plant });
            }
    
            // Add other conditions based on `req` as needed
            if (req.calibrationId && req.calibrationId > 0) {
                query.andWhere('ed.calibration_id = :calibrationId', { calibrationId: req.calibrationId });
            }
        }
    
        console.log(query.getSql(), "Generated SQL Query"); // Log the generated SQL query
        return await query.getRawMany();
    }
    
}